var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
// removed import of scss-style
export const Anchor = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("a", Object.assign({ className: classnames('Anchor', className) }, rest), children));
};
export const Button = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("button", Object.assign({ className: classnames('Button', className) }, rest), children));
};
export const Heading1 = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("h1", Object.assign({ className: classnames('Heading1', className) }, rest), children));
};
export const Heading2 = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("h2", Object.assign({ className: classnames('Heading2', className) }, rest), children));
};
export const Heading3 = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("h3", Object.assign({ className: classnames('Heading3', className) }, rest), children));
};
export const Heading4 = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("h4", Object.assign({ className: classnames('Heading4', className) }, rest), children));
};
export const Heading5 = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("h5", Object.assign({ className: classnames('Heading5', className) }, rest), children));
};
export const Heading6 = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("h6", Object.assign({ className: classnames('Heading6', className) }, rest), children));
};
export const Heading7 = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("h6", Object.assign({ className: classnames('Heading7', className) }, rest), children));
};
export const Hr = props => {
    const { className } = props, rest = __rest(props, ["className"]);
    return React.createElement("hr", Object.assign({ className: classnames('Hr', className) }, rest));
};
export const Image = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return React.createElement("img", Object.assign({ className: classnames('Image', className) }, rest));
};
export const ListItem = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("li", Object.assign({ className: classnames('ListItem', className) }, rest), children));
};
export const Paragraph = props => {
    const { className, children, small, bold, italic } = props, rest = __rest(props, ["className", "children", "small", "bold", "italic"]);
    return (React.createElement("p", Object.assign({ className: classnames('Paragraph', { 'Paragraph--Small': small }, { 'Paragraph--Bold': bold }, { 'Paragraph--Italic': italic }, className) }, rest), children));
};
export const Label = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("p", Object.assign({ className: classnames('Label', className) }, rest), children));
};
export const LabelSticker = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("p", Object.assign({ className: classnames('LabelSticker', className) }, rest), children));
};
export const InputErrorMessage = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("p", Object.assign({ className: classnames('InputErrorMessage', className) }, rest), children));
};
export const UnsortedList = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("ul", Object.assign({ className: classnames('UnsortedList', className) }, rest), children));
};
export const TextArea = props => {
    const { className, children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("textarea", Object.assign({ className: classnames('TextArea', className) }, rest), children));
};
